import { Routes } from '@angular/router';
import { DashboardRouteContext } from '@context/old_index';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { ClientAdmin, Previewer, SysAdmin, FormsAdministrator } from './role-constants';
import { OidcAuthRouteGuardService } from '@auth/services/oidc-auth-route-guard';
import { RoleGuardService } from '@roles/services/role-guard.service';
import { PmaPermissionsGuardService } from '@roles/services/pma-permissions-guard.service';
import { SystemConfigurationPageComponent } from '@admin/containers/system-configuration-page/system-configuration-page.component';
import { EmailTemplatesPageComponent } from '@admin/email-templates/containers/email-templates-page/email-templates-page.component';
import { WellKnownRoutePaths } from './well-known-route-paths';
import { WidgetAdminPageComponent } from '@admin/containers/widget-admin-page/widget-admin-page.component';
import { ProfileAndDashboardConfigPageComponent } from '@admin/profile/containers/profile-and-dashboard-configuration-page/profile-and-dashboard-configuration-page.component';
import { UsersProfilesPageComponent } from '@user-profiles/containers/user-profiles-page/user-profiles-page.component';
import { ClientAdminPageComponent } from '@admin/client-client-parent/containers/client-admin-page/client-admin-page.component';
import { ClientParentAdminPageComponent } from '@admin/client-client-parent/containers/client-parent-admin-page/client-parent-admin-page.component';
import { MojoSystemSettingsComponent } from '@admin/containers/mojo-system-settings/mojo-system-settings.component';
import { SupportPageComponent } from
  '@feature/_app_modules/mojo/mojo-admin-dashboard/container/support-page/support-page.component';
import { SupplierOtherCreditorAdminPageComponent } from
  '@admin/supplier-other-creditor/containers/supplier-other-creditor-admin-page/supplier-other-creditor-admin-page.component';
import { MfsProductService } from '@product/services/mfs-product.service';
import { MftProductService } from '@product/services/mft-product.service';
import { CancelActivitiesComponent } from '@feature/_app_modules/mojo/cancel-activities/cancel-activities/cancel-activities.component';
import {AddOnGuard} from "@auth/services/add-on-guard.service";



export const administrationRoutes: Routes = [

  // SystemConfigurationPageComponent
  {
    data: {
      defaultRoute: '/config',
      product: MojoWellKnownNames.Products.Mci,
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },
    path: 'config',
    component: SystemConfigurationPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // EmailTemplatesPageComponent
  {
    data: {
      defaultRoute: '/main',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: WellKnownRoutePaths.MojoDashboards.emailTemplates,
    component: EmailTemplatesPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // WidgetAdminPageComponent
  {
    data: {
      defaultRoute: '/widget-admin',
      product: MojoWellKnownNames.Products.Mci,
      roles: [
        ClientAdmin,
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: 'widget-admin',
    component: WidgetAdminPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]

  },

  // FaqAdminPageComponent
  {
    data: {
      defaultRoute: '/manage-faqs',
      product: MojoWellKnownNames.Products.MojoDashboard,
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: WellKnownRoutePaths.MojoDashboards.faqPage,
    loadChildren: () => import('@feature/_app_modules/faq-admin/faq-admin.module').then(m => m.FaqAdminModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]

  },
  // Dashboard WidgetAdminPageComponent
  {
    data: {
      defaultRoute: '/mojo-widget-admin',
      product: MojoWellKnownNames.Products.MojoDashboard,
      roles: [
        ClientAdmin,
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: WellKnownRoutePaths.MojoDashboards.manageWidgets,
    component: WidgetAdminPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]

  },

  // support page
  {
    data: {
      product: MojoWellKnownNames.Products.MojoDashboard,
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: WellKnownRoutePaths.MojoDashboards.supportPage,
    component: SupportPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // cancel activities
  {
    data: {
      product: MojoWellKnownNames.Products.MojoDashboard,
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: WellKnownRoutePaths.MojoDashboards.cancelActivities,
    component: CancelActivitiesComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // Mci Profile and Dashboard Configuration Page
  {
    data: {
      defaultRoute: '/main',
      product: MojoWellKnownNames.Products.Mci,
      dashboardDesignerPath: '/mci-dashboard-designer',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: 'profile-config',
    component: ProfileAndDashboardConfigPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // Mojo Profile and Dashboard Configuration Page
  {
    data: {
      defaultRoute: '/main',
      product: MojoWellKnownNames.Products.MojoDashboard,
      dashboardDesignerPath: '/mojo-dashboard-designer',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: WellKnownRoutePaths.MojoDashboards.manageProfiles,
    component: ProfileAndDashboardConfigPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // Suppliers Profile and Dashboard Configuration Page
  {
    data: {
      defaultRoute: '/main',
      product: MojoWellKnownNames.Products.MojoForSuppliers,
      dashboardDesignerPath: '/mfs-dashboard-designer',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: MfsProductService.manageProfiles,
    component: ProfileAndDashboardConfigPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // Tenants Profile and Dashboard Configuration Page
  {
    data: {
      defaultRoute: '/main',
      product: MojoWellKnownNames.Products.MojoForTenants,
      dashboardDesignerPath: '/mft-dashboard-designer',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: MftProductService.manageProfiles,
    component: ProfileAndDashboardConfigPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },


  // User Profile Configuration Page
  {
    data: {
      defaultRoute: '/main',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: WellKnownRoutePaths.MojoDashboards.assignProfiles,
    component: UsersProfilesPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // Supplier Profile Configuration Page
  {
    data: {
      defaultRoute: '/main',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: MfsProductService.assignProfiles,
    component: SupplierOtherCreditorAdminPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },




  // Client Admin Page
  {
    data: {
      defaultRoute: '/main',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: 'client-admin',
    component: ClientAdminPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // Client Parent Admin Page
  {
    data: {
      defaultRoute: '/main',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },

    path: 'client-parent-admin',
    component: ClientParentAdminPageComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // Mojo System Settings
  {
    data: {
      defaultRoute: '/main',
      product: MojoWellKnownNames.Products.MojoDashboard,
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
      routeContext: DashboardRouteContext.create('None', false)
    },
    path: WellKnownRoutePaths.MojoDashboards.systemSettings,
    component: MojoSystemSettingsComponent,
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  // AdminDashboardComponent
  {
    data: {
      addOn: MojoWellKnownNames.AddOnCodes.WS004_Mci,
      routeContext: DashboardRouteContext.create('None', false),
      defaultRoute: '/main',
      roles: [
        ClientAdmin,
        SysAdmin,
        Previewer
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
    },
    path: 'admin',
    loadChildren: () => import('@feature/_app_modules/mojo-for-clients/admin-dashboard/admin-dashboard.module').then(m => m.AdminDashboardModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, AddOnGuard, PmaPermissionsGuardService]
  },

  // MasterAdminDashboardComponent
  {
    data: {
      routeContext: DashboardRouteContext.create('None', false),
      defaultRoute: '/main',
      roles: [
        ClientAdmin,
        SysAdmin,
        Previewer
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
    },
    path: WellKnownRoutePaths.MojoDashboards.selectProductDashboard,
    loadChildren: () => import('@feature/_app_modules/mojo/master-admin-dashboard/master-admin-dashboard.module').then(m => m.MasterAdminDashboardModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  //MojoAdminDashboardComponent
  {
    data: {
      routeContext: DashboardRouteContext.create('None', false),
      defaultRoute: '/main',
      roles: [
        ClientAdmin,
        SysAdmin,
        Previewer
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
    },
    path: WellKnownRoutePaths.MojoDashboards.adminDashboard,
    loadChildren: () => import('@feature/_app_modules/mojo/mojo-admin-dashboard/mojo-admin-dashboard.module').then(m => m.MojoAdminDashboardModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },

  //IdsAdminDashboardComponent
  {
    data: {
      routeContext: DashboardRouteContext.create('None', false),
      defaultRoute: '/main',
      roles: [
        SysAdmin
      ],
      pmaPermissions: [
        FormsAdministrator
      ],
    },
    path: WellKnownRoutePaths.MojoDashboards.identityServerDashboard,
    loadChildren: () => import('@feature/_app_modules/mojo/ids-admin-dashboard/ids-admin-dashboard.module').then(m => m.IdsAdminDashboardModule),
    canActivate: [OidcAuthRouteGuardService, RoleGuardService, PmaPermissionsGuardService]
  },


];
